import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

export interface IMessage {
  name?: string;
  email?: string;
  enterprise?: string;
  tel?: string;
  message?: string;
}

@Injectable()
export class EmailService {
  private emailUrl = './assets/email.php';

  constructor(private http: HttpClient) { }

  sendEmail(message: IMessage): Observable<IMessage> | any {
    return this.http.post(this.emailUrl, message)
      .map(response => {
        console.log('Sending email was successfull', response);
        return response;
      })
      .catch(error => {
        console.log('Sending email got error', error);
        return Observable.throw(error);
      });
  }
}



// WEBPACK FOOTER //
// /home/federicblack/public_html/GrupoCristalino/src/app/email.service.ts